import { Flex } from 'antd';
import styles from './ai-agent.module.scss';
import { useParams } from 'react-router-dom';
import { AiAgent as AiAgentModule } from '@modules/ai-agent';

export const AiAgent = () => {
  const { agentId } = useParams();

  return (
    <Flex className={styles.root}>
      <AiAgentModule agentId={Number(agentId)} />
    </Flex>
  );
};
